import styled from '@emotion/styled';
import { ListItemButton } from '@mui/material';
import { NavLink as RouterDomNavLink } from 'react-router-dom';

import { Colors } from 'styles/variables/colors';

type Props = {
    margin?: string;
    marginRight?: string;
};

export const MenuItem = styled(ListItemButton)<Props>`
    padding: 0;
    margin-left: ${(props) => (props.margin ? props.margin : '')};
`;

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    padding: 11px 20px;
    width: 100%;
`;

export const NavLink = styled(RouterDomNavLink)`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    padding: 11px 20px;
    width: 100%;
`;

type SVGProps = {
    fill?: string;
    marginRight?: string;
};

export const SvgContainer = styled.div<SVGProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${(props) => (props.marginRight ? props.marginRight : '13px')};

    & svg {
        fill: ${(props) => (props.fill ? `${props.fill}` : `${Colors.darkGray}`)};
    }
`;

export const Text = styled.span`
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: ${Colors.darkGray};
`;
